import { t } from 'Src/i18n';
type AttendeeNamePlaceholderAttendeeType = {
  readonly firstName?: string;
  readonly lastName?: string;
  readonly civility?: string;
};
export const getAttendeeNamePlaceholder = (
  attendee: AttendeeNamePlaceholderAttendeeType,
  isKid?: boolean,
  isMain?: boolean,
) => {
  const { firstName, lastName, civility } = attendee;
  let attendeeLabel = isKid
    ? t('booking.participants.otherKidsInfosHeader.title')
    : t('booking.participants.otherAdultsInfosHeader.title');

  if (isMain) {
    attendeeLabel = t('booking.participants.personnalInfosHeader.title');
  }

  if (firstName && lastName && civility) {
    attendeeLabel = `${civility} ${firstName} ${lastName}`;
  }

  return attendeeLabel;
};
export const getNumberOfAdultsAndChildren = (
  quantityOfChildren: number,
  quantityOfAdults: number,
) => {
  if (quantityOfChildren === 0) {
    return `${quantityOfAdults} ${t('booking.common.adults')}`;
  }

  if (quantityOfChildren === 1) {
    return `${quantityOfAdults} ${t('booking.common.adults')} - ${quantityOfChildren} ${t('booking.common.child')}`;
  }

  if (quantityOfChildren > 1) {
    return `${quantityOfAdults} ${t('booking.common.adults')} - ${quantityOfChildren} ${t('booking.common.children')}`;
  }
};
